import { render, staticRenderFns } from "./gestionVentes.vue?vue&type=template&id=3a26ef08&"
import script from "./gestionVentes.vue?vue&type=script&lang=js&"
export * from "./gestionVentes.vue?vue&type=script&lang=js&"
import style0 from "./gestionVentes.vue?vue&type=style&index=0&id=3a26ef08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports